module.exports = __webpack_public_path__ + "static/media/schody32 - schody drewniane zabiegowe.1c7d37d4.jpg";